import config from '@/config'

export default {
  combine: {
    confirm_password: "確認密碼",
    change_password: "更改密碼",
    old_password: "舊 @:ui.password",
    new_password: "@:ui.new @:ui.password",
    confirm_security_code: "確認@:ui.security_code",
    first_time_login: "首次登錄",
    security_authentication: "安全認證",
    update_security: "更新安全性",
    disable_security: "禁用安全",
    add_account: "添加帳戶",
    add_sub_account: "添加子帳戶",
    edit_operator: "編輯運算子",
    edit_account: "編輯帳戶",
    edit_member: "編輯成員",
    approve_ticket: "批准工單",
    reject_ticket: "拒絕工單",
    add_bank_account: "添加銀行帳戶",
    edit_bank_account: "編輯銀行帳戶",
    reset_threshold: "重置閾值",
    adjust_balance: "調整平衡",
    adjust_member: "調整成員",
    configure_bank_setting: "配置銀行設置",
    account_setup: "帳戶設置",
    bank_transfer: "銀行轉帳",
    edit_bank_member: "編輯銀行成員",
    edit_ticket: "編輯工單",
    edit_vip: "編輯VIP",
    knock_off_promo: "山寨促銷",
    edit_authority: "編輯許可權",
    reset_password: "重置密碼",
    update_password: "更新密碼",
    member_summary: "成員摘要",
    reply_review: "回復評論",
    edit_affiliate: "編輯代理",
    edit_bank_affiliate: "編輯銀行代理",
    approve_affiliate_ticket: "批准代理工單",
    check_free_spin: "檢查免費旋轉",
    reject_affiliate_ticket: "拒絕代理工單",
    wallet_adjust: "錢包調整",
    update_comm_package: "更新通信包",
    approve_affiliate: "批准代理",
    sub_acc_detail_affiliate: "子帳戶明細代理",
    get_tac: "獲取 OTP",
    add_coupon: "添加優惠券",
    update_coupon: "更新優惠券",
    issue_free_spin: "發行免費旋轉",
    get_bank_tac: "獲取銀行一次性密碼",
    update_global_setting: "更新全域設置",
    add_platform: "添加平臺",
    edit_platform: "編輯平臺",
    add_bank_group: "添加銀行組",
    edit_bank_group: "編輯銀行組",
    update_maintenance_schedule: "更新維護計畫",
    add_withdrawal_limit: "添加提款限額",
    edit_withdrawal_limit: "編輯提款限額",
    add_campaign: "添加活動",
    edit_campaign: "編輯廣告系列",
    add_promo_group: "添加推廣組",
    edit_promo_group: "編輯推廣組",
    update_team: "更新團隊",
    update_result: "更新結果",
    insert_result: "插入結果",
    bet_list: "投注清單",
    result_list: "結果清單",
    add_promo: "添加促銷",
    raise_deposit_ticket: "提高存款票",
    bank_adjust: "銀行調整",
    promo_member_assign: "推廣會員分配",
    bonus_issue: "獎金發行",
    update_vip: "更新VIP",
    update_member_profile: "更新會員資料",
    change_withdrawal_limit: "更改提款限額",
    change_bank_group: "Change Bank Group",
    change_promotion_group: "變革推進組",
    edit_promo_signup: "編輯促銷註冊",
    update_provider_bet_limit: "更新提供商投注限額",
    update_bet_limit: "更新投注限額",
    update_member_bet_limit: "更新會員投注限額",
    edit_bank_account_group: "編輯銀行帳戶組",
    redeposit_ticket: "」重新存入機票",
    edit_promotion_group: "編輯推廣組",
    edit_promotion_group_norm: "在組中管理促銷",
    get_inbox_list: "獲取收件箱清單",
    view_result_changes_detail: "查看結果更改詳細資訊",
    edit_promotion_signup: "編輯促銷註冊",
    edit_bet_limit: "編輯投注限額",
    edit_provider_game_off: "編輯提供程式遊戲關閉",
    edit_provider_rtp: "編輯供應商 RTP",
    get_rebate: "獲得回扣",
    get_recent_deposit: "獲取最近的存款",
    add_survey: "添加調查",
    add_announcement_banner: "添加公告橫幅",
    edit_announcement_banner: "編輯公告橫幅",
    move_announcement_banner: "移動公告橫幅",
    add_promotion_banner: "添加促銷橫幅",
    edit_promotion_banner: "編輯促銷橫幅",
    unlink_banner: "解除連結",
    move_promotion_banner: "移動推廣橫幅",
    add_slide_banner: "添加幻燈片橫幅",
    edit_slide_banner: "編輯幻燈片橫幅",
    move_slide_banner: "移動幻燈片橫幅",
    add_seo_page: "添加 SEO 頁面",
    edit_seo_page: "編輯 SEO 頁面",
    clear_outstanding: "清除優秀",
    add_ip_whitelist: "添加IP白名單",
    bonus_issue_bulk: "批量獎金發行",
    edit_bank_member_ewallet: "「編輯銀行會員（電子錢包）」",
    redeposit: "再存入",
    reject_approved_ticket: "拒絕已批准的工單",
    audit_ticket: "審計票",
    review_ticket: "複查票證",
    edit_promotion_group_norm_seq: "管理組內的升級順序",
    edit_promo_provider_list: "編輯促銷供應商清單",
    edit_promo_payment_option: "編輯促銷付款選項",
    edit_campaign_provider_list: "編輯廣告活動供應商清單",
    update_comm: "更新傭金",
    update_carry_over: "更新結轉",
    review_affiliate_ticket: "查看代理工單",
    audit_affiliate_ticket: "審計代理工單",
    get_tac_affiliate: "獲取 OTP（代理）",
    raise_deposit_ticket_gateway: "籌集存款票（網關）",
    direct_audit_ticket: "審計票證（直接）",
    get_rollback_detail: "獲取回滾詳細資訊",
    get_reject_detail: "獲取拒絕詳細資訊",
    manual_approve_ticket: "批准工單（手動）",
    add_label: "添加標籤",
    edit_label: "編輯標籤",
    rollback_processing_ticket: "回滾處理票證",
    update_iframe_url: "更新 Iframe URL",
    edit_exchange_rate: "編輯匯率",
    add_vip: "添加VIP",
    add_turnover_tier: "添加營業額等級",
    edit_turnover_tier: "編輯營業額層",
    edit_mission_reward: "編輯任務獎勵",
    enable_mission_reward: "啟用任務獎勵",
    get_member_label_list: "成員標籤清單",
    add_rescue_fund: "增加救助基金",
    get_custom_member_list: "自定義成員清單",
    get_rescue_fund_provider: "獲取救援基金提供者",
    add_game_exclude: "添加遊戲排除",
    delete_game_exclude: "刪除排除遊戲",
    domain_custom_add_assign: "添加域",
    add_domain_batch: "添加域（批量）",
    update_payment_provider_vip: "更新支付提供者Vip",
    update_campaign: "更新活動",
    purchase_domain: "購買功能變數名稱",
    apply_domain: "應用域",
    edit_access_control: "編輯訪問控制",
    add_domain: "添加域",
    operator_wallet_adjust: "Adjust 運營商錢包",
    update_payment_provider_desc: "更新支付提供者描述",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.add @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "設置徽標",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    provider_pt_operator_update: "提供者 PT 運營商更新",
    provider_pt_global_update: "提供者 PT 全球更新",
    payment_option_callback_update: "回調 URL 更新",
    change_payment_option_seq: "付款選項順序",
    change_payment_mode_status: "付款方式狀態更新",
    change_payment_option_recommend: "付款方式推薦",
    change_payment_option_credential: "付款選項憑證",
    change_payment_option_limit: "付款方式限額",
    change_payment_option_vip: "支付選項VIP",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
    add_leaderboard: "@:ui.add @:ui.leaderboard",
    edit_leaderboard: "@:ui.edit @:ui.leaderboard",
    add_phone: "@:ui.add @:ui.phone",
    adjust_free_balance: "Adjust Free Balance",
    edit_ai_assistant: "@:ui.edit @:ui.ai_assistant",
    change_payment_option_desc: "付款選項說明",
    fund_transfer_provider: "資金轉帳提供者",
    manual_deposit: "手動存款",
    change_linkage_desc: "關聯說明",
    change_linkage_risk_weight: "關聯風險權重",
    add_promo_voucher: "@:ui.add @:ui.promotion_voucher",
    edit_promotion_voucher_end_date: "@:ui.edit @:ui.promotion_voucher @:ui.end_date",
    get_voucher_custom_member_list: "取得優惠券自訂會員列表",
    redeposit_ticket_voucher: "重新入金工單憑證",
    approve_ticket_voucher: "核准工單憑證",
    reject_ticket_voucher: "拒絕工單憑證",
    raise_deposit_ticket_voucher: "建立入金工單憑證",
    raise_deposit_ticket_voucher_gateway: "建立入金工單憑證（閘道）",
    get_voucher_list: "取得憑證列表",
    get_message_list: "取得訊息列表",
    edit_free_credit: "@:ui.edit @:ui.free_credit",
    knock_off_free_credit_member: "取消免費信用會員",
    free_credit_manual_assign: "免費信用手動指派",
    review_fcp_ticket: "審核免費信用供應商工單",
    audit_fcp_ticket: "稽核免費信用供應商工單",
    reject_fcp_ticket: "拒絕免費信用供應商工單",
    approve_fcp_ticket: "批准免費信用供應商工單",
    edit_trigger: "編輯觸發條件",
    edit_trigger_status: "編輯觸發狀態",
    adjust_voucher_balance: "調整優惠券餘額",
    clear_free_credit: "清除免費額度",
    add_deposit_tier: "新增存款等級",
    edit_deposit_tier: "編輯存款等級",
    add_leaderboard_banner: "新增排行榜橫幅",
    edit_leaderboard_banner: "編輯排行榜橫幅",
    add_referral_banner: "新增推薦橫幅",
    edit_referral_banner: "編輯推薦橫幅",
    edit_vip_icon: "編輯 VIP 圖示",
    add_reward_rain: "新增 Reward Rain",
    edit_reward_rain: "編輯 Reward Rain",
    add_reward_rain_session: "新增 Reward Rain 場次",
    edit_reward_rain_session: "編輯 Reward Rain 場次",
    edit_reward_rain_session_end_date: "編輯 Reward Rain 場次結束日期",
    add_news: "新增新聞",
    edit_news: "編輯新聞",
  },
  short: {
    deposit_amount: "存款金額",
    base_amount: "基本金額",
    bonus_amount: "獎金金額",
    target_amount: "目標金額",
    knockoff_by: "K.O By",
    knockoff_date: "K.O Date",
    incoming_threshold: "傳入閾值",
    incoming_frequency: "傳入頻率",
    outgoing_threshold: "傳出閾值",
    outgoing_frequency: "出頻",
    account_balance: "帳戶結餘",
    claim_type: "」聲明類型",
    bonus_rate: "獎金率",
    max_bonus: "最高獎金",
    rollover: "翻車",
    criteria: "標準",
    start_time: "開始時間",
    end_time: "末日",
    monday: "星期一",
    tuesday: "星期二",
    wednesday: "星期三",
    thursday: "星期四",
    friday: "星期五",
    saturday: "星期六",
    sunday: "周日",
    status: "狀態",
    bonus_rate_percent: "獎金率（%)",
    valid_turnover: "有效營業額",
    deposit_count: "存款計數",
    withdrawal_amount: "提款金額",
    withdrawal_count: "提款計數",
    adjustment_amount: "調整金額",
    referee_count: "裁判計數",
    signup_count: "註冊計數",
    verified_count: "已驗證計數",
    active_member: "活躍會員",
    ftd_count: "FTD 計數",
    ftd_amount: "FTD Amt",
    working_date: "工作日期",
    recipient_bank_id: "收款銀行ID”",
    recipient_bank_acc_no: "收款銀行帳戶編號",
    recipient_bank_acc_holder: "收款銀行帳戶持有人",
    sender_bank: "「發送方銀行」",
    sender_bank_acc_no: "匯款銀行賬戶編號",
    sender_bank_acc_holder: "發件者銀行帳戶持有人",
    unique_login_count: "唯一登錄計數",
    unique_deposit_count: "唯一存款計數",
    unique_withdrawal_count: "唯一提款次數",
    second_deposit_count: "第二次存款計數",
    reject_date: "拒絕日期",
    processing_date: "處理日期",
    deposit_withdrawal_different: "存款取款不同",
    external_id: "外部ID",
    draft_version: "草案版本",
    prod_version: "產品版",
    purchased_date: "購買日期",
    completed_amount: "已完成金額",
    min_amount: "最低金額",
    max_amount: "最高金額",
    total_claimed_amount: "已領取總金額",
  },
  date_ranges: {
    0: "今天",
    1: "昨天",
    2: "這個月",
    4: "上個月",
  },
  langList: {
    EN: "英語",
    CN: "中文",
    PHP: "菲律賓",
    esp: "西班牙文",
    RUS: "俄羅斯語",
    VI: "越南語",
    MS: "馬來語",
    NE: "尼泊爾語",
    CT: "中文（台灣）",
    BN: "孟加拉語"
  },
  menulist: {
    home: "家",
    hot: "熱",
    slot_game: "槽",
    casino: "賭場",
    sportsbook: "體育博彩",
    fishing: "釣魚",
    lottery: "彩票",
    poker: "撲克",
    hash_game: "哈希遊戲",
    sabong: "薩邦",
    promotion: "促銷",
    review: "評論 |評論",
    news: "新聞",
    live_stream: "直播",
    vip: "貴賓",
    referral: "轉介",
    favourite: "最愛",
    mission: "任務（小遊戲）",
    spin: "旋轉",
    leaderboard: "排行榜",
    account: "帳戶",
    deposit: "押金",
    withdrawal: "提款",
    bet_history: "投注歷史",
    pending_status: "待處理狀態",
    change_password: "更改密碼",
    profile: "個人資料",
    banking_details: "銀行資料",
    inbox: "收件匣",
    voucher: "憑證",
    wallet: "錢包",
    statement: "」聲明",
    download: "下載",
    game: "遊戲",
    special: "特別",
    misc: "雜項",
    contact_us: "聯繫我們",
    e_sportsbook: "「電子體育博彩」",
    lotto: "樂透",
    p2p: "P2P",
    other: "其他",
    vip2: "貴賓2",
    referral2: "推薦2",
    event: "事件",
    daily_reward: "每日獎勵",
    play2earn: "玩 2 賺",
    redemption: "救贖",
    card_board: "紙板",
    lobby: "大堂",
    in_house: "內部",
    transfer: "轉讓",
    horse_racing: "《賽馬》",
    register: "註冊",
    login: "登錄",
    transaction_history: "交易記錄",
    bingo: "賓果遊戲",
    member: "會員",
    arcade: "街機",
    crash: "崩潰",
    freeplay: "免費玩",
    others: "其他",
  },

  ok: "好",
  cancel: "取消",
  login: "登入",
  logout: "註銷",
  add: "添加",
  edit: "編輯",
  delete: "刪除",
  refresh: "刷新",
  action: "行動",
  id: "ID",
  name: "名稱",
  all: "全部",
  search: "搜索",
  remove: "刪除",
  save: "保存",
  account: "帳戶",
  settings: "設置",
  on: "開",
  off: "關閉",
  new: "新",
  clear: "清除",
  users: "使用者 |使用者",
  username: "使用者名",
  password: "密碼",
  created_on: "創建",
  active: "主動",
  page_size: "頁面大小",
  status: "狀態",
  result: "結果",
  close: "關閉",
  back: "返回",
  show: "顯示",
  login_id: "登錄ID",
  date_time: "日期時間",
  ip_address: "IP位址",
  domain_name: "域名",
  browser_agent: "瀏覽器代理",
  action_by: "行動者",
  details: "詳情",
  key: "鑰匙 |鑰匙",
  value: "價值 |價值觀",
  from: "寄件人",
  to: "到",
  type: "類型",
  criteria: "標準",
  log: "日誌",
  report: "報告",
  security_tag: "安全標籤",
  security_code: "安全代碼",
  submit: "提交",
  disable: "禁用",
  operators: "運營商 |運算子",
  members: "成員",
  account_id: "帳戶 ID",
  confirm_password: "確認密碼",
  full_name: "全名",
  contact_phone: "聯繫電話",
  contact_email: "聯繫電子郵件",
  dashboard: "儀錶板",
  sub_account: "子帳戶",
  authority_option: "許可權選項",
  banks: "銀行 |銀行",
  login_ip: "登錄IP",
  block: "塊",
  profile_id: "個人資料 ID",
  suspend: "暫停",
  deposit: "存款",
  withdrawal: "提款",
  bulk_withdrawal: "批量提款",
  rejected: "拒絕",
  processed: "已處理",
  pending: "待處理",
  member: "會員",
  amount: "金額",
  bank_acc_no: "銀行帳戶編號",
  deposit_date: "存款日期",
  deposit_method: "存款方式",
  approve: "批准",
  reject: "拒絕",
  remark: "備註",
  ticket_detail: "門票詳情",
  promo: "促銷",
  package: "包",
  created_date: "創建日期",
  currency: "貨幣",
  bank_acc_holder: "銀行帳戶持有人",
  ref_no: "參考編號",
  vip: "VIP",
  modified_date: "修改日期",
  modified_by: "修改者",
  bank_member: "銀行會員",
  bank_operator: "銀行運營商",
  bank_name: "銀行名稱",
  bank_acc_type: "銀行帳戶類型",
  account_balance: "帳戶餘額",
  threshold: "閾值",
  incoming: "傳入",
  outgoing: "外向",
  frequency: "頻率",
  reset_threshold: "重設門檻",
  adjust_balance: "調整餘額",
  bank_from: "銀行來源",
  bank_to: "銀行到",
  attachment: "附件",
  sender_bank: "匯款銀行",
  sender_bank_acc_no: "匯款銀行帳號",
  sender_bank_acc_holder: "匯款人姓名",
  audit: "審計",
  action_status: "行動狀態",
  action_date: "行動日期",
  promotion: "優惠活動",
  promo_id: "促銷ID",
  promo_name: "促銷名稱",
  package_id: "包 ID",
  claim_type: "申領類型",
  bonus_rate: "紅利比例",
  max_bonus: "最高紅利",
  rollover: "流水要求",
  start_date: "開始日期",
  end_date: "結束日期",
  adj_amount: "調整金額",
  promotion_member: "促銷會員",
  on_going: "繼續前進",
  knock_off: "山寨山寨",
  all_ongoing: "一切正在進行中",
  deposit_amount: "存款金額",
  base_amount: "基本金額",
  bonus_amount: "紅利金額",
  target_amount: "目標金額",
  claim_date: "索賠日期",
  accumulate_win: "累積贏",
  accumulate_turnover: "累積營業額",
  bonus: "獎金",
  bonus_log: "獎金日誌",
  member_id: "會員ID",
  before_balance: "平衡之前",
  transfer_amount: "轉帳金額",
  after_balance: "平衡之後",
  created_by: "創建者",
  bonus_name: "獎金名稱",
  bonus_desc: "獎金說明",
  bonus_type: "獎金類型",
  add_promo: "新增優惠活動",
  bonus_value: "獎金價值",
  attach_promo: "附加促銷",
  daily_statement: "《每日報表》",
  working_date: "工作日期",
  opening_balance: "期初餘額",
  turnover: "營業額",
  valid_turnover: "有效流水",
  winlose: "WinLose",
  withdrawal_amount: "提款金額",
  closing_balance: "期末餘額",
  sub_total: "小計",
  grand_total: "總計",
  daily_winlose: "《每日風光》",
  game_result_slots: "遊戲結果（老虎機）",
  game_result_livecasino: "遊戲結果（真人娛樂場）",
  game_result_rebate: "遊戲結果（回扣）",
  game_result_sportsbook: "比賽結果（體育博彩）",
  game_result_cockfight: "遊戲結果（鬥雞）",
  game_result_rescue: "遊戲結果（救援）",
  game_result_others: "遊戲結果（其他）",
  bet_count: "投注計數",
  result_id: "結果ID",
  bet_time: "投注時間",
  result_time: "結果時間",
  payout: "支付",
  game_type: "遊戲類型",
  game_name: "遊戲名稱",
  game_provider: "遊戲提供者",
  reset: "重置",
  mode: "模式",
  balance: "平衡",
  min_bal_knock_off_promo: "Min Bal.（自動敲除促銷）",
  social_account: "社交帳號",
  wechat: "微信",
  telegram: "電報",
  whatsapp: "Whatsapp",
  facebook: "臉書",
  instagram: "Instagram",
  login_log: "登錄日誌",
  platform: "平臺",
  bank_statement: "銀行對帳單",
  transfer_date: "轉讓日期",
  detail: "細節",
  date: "日期",
  transfer_list: "「轉會名單」",
  credit: "信用",
  badge: "徽章",
  debit: "借方",
  month: "月",
  unblock: "解鎖",
  unblock_member: "取消阻止成員",
  unblock_operator: "解鎖運營商",
  referrer_id: "推薦人ID",
  referrer_code: "推薦人代碼",
  referral_code: "推薦代碼",
  bonus_and_adjustment: "獎金和調整",
  adjustment: "調整",
  incoming_amount_threshold: "入帳金額閾值",
  outgoing_amount_threshold: "支付金額閾值",
  knock_off_by: "Knock Off By",
  knock_off_date: "《山寨約會》",
  total_turnover: "總營業額",
  total_winlose: "總贏",
  total_deposit: "總存款",
  total_member: "會員總數",
  active_player: "活躍玩家",
  top_winner: "頭獎",
  top_loser: "頂級輸家",
  winner: "優勝者",
  loser: "失敗者",
  deposit_count: "存款次數",
  withdrawal_count: "提款次數",
  alert: "警報",
  incoming_threshold: "入帳門檻",
  incoming_frequency: "入帳頻率",
  outgoing_threshold: "出帳門檻",
  outgoing_frequency: "出帳頻率",
  reset_password: "重設密碼",
  transfer: "轉帳",
  company_bank: "公司銀行",
  company_bank_acc_no: "公司銀行賬戶編號",
  company_bank_acc_holder: "公司銀行帳戶持有人",
  registered_member: "註冊會員",
  promotion_report: "晉陞報告",
  deposited_member: "存入會員",
  referred_member: "被推薦會員",
  validated_on: "驗證時間",
  first_deposit: "首次存款",
  reward: "獎勵",
  inbox: "收件匣",
  manual_bonus: "手動獎金",
  review: "評論",
  reviews: "評論",
  review_list: "評論清單",
  review_detail: "評論詳情",
  reply_review: "回覆評論",
  comment: "評論",
  reply: "回復",
  recipient_no: "收件者編號",
  question: "問題",
  rating: "評級",
  content: "內容",
  image: "圖像",
  monthly_rating: "月度評分",
  affiliate: "代理",
  affiliate_list: "代理商清單",
  affiliate_code: "代理代碼",
  approved_by: "批准者",
  approved_date: "批准日期",
  bank_affiliate: "銀行代理",
  bank_id: "銀行ID",
  ticket_detail_affiliate: "票務詳情代理",
  pending_application: "待處理申請",
  pending_review_withdrawal: "待處理和審查提款",
  unblock_affiliate: "解鎖代理",
  wallet_adjust: "錢包調整",
  comm_package: "通訊包",
  affiliate_id: "代理 ID",
  sub_account_detail: "子帳戶詳情",
  daily_winlose_affiliate: "每日溫洛斯（代理）",
  daily_deposit_affiliate: "每日存款（代理）",
  export_excel: "導出Excel",
  get_tac: "取得 OTP",
  tac_code: "一次性密碼",
  expiry_date: "有效期",
  inactive: "非活動",
  last_deposit_date: "「最後存款日期」",
  coupon: "優惠券",
  allocated: "已分配",
  claimed: "聲稱",
  approved: "已批准",
  coupon_code: "優惠券代碼",
  coupon_quota: "優惠券配額",
  current_allocated: "當前分配",
  new_allocated: "新分配",
  update: "更新",
  copy: "複製",
  bonus_rate_percent: "紅利比例 (%)",
  coupon_desc: "優惠券說明",
  both: "兩者",
  issue_free_spin: "發放免費旋轉",
  game: "遊戲",
  max_win_amount: "最高贏取金額",
  utm_list: "UTM 清單",
  search_by_member: "按會員搜索",
  campaign: "活動",
  deposited: "已存款",
  search_by_id: "按ID搜索",
  get_bank_tac: "取得銀行 OTP",
  bank_statement_daily: "銀行月結單（每日）",
  transfer_type: "轉帳類型",
  audit_freebies_list: "審計免費贈品清單",
  acknowledge: "」承認",
  submit_acknowledgement: "提交確認",
  is_ack: "是 Ack",
  yes: "是的",
  no: "不",
  audit_rescue_fund_list: "《審計救助基金名單》",
  global_setting: "全域設置",
  signup_ip: "註冊IP",
  last_login_ip: "「上次登錄IP」",
  last_login_time: "「上次登錄時間」",
  link: "連結",
  is_default: "預設",
  is_public: "是公開的",
  bank_group: "銀行集團",
  set_default: "設置預設值",
  group_id: "組ID",
  group_name: "組名",
  provider_maintenance: "提供者維護",
  provider_code: "提供者代碼",
  provider_name: "提供者名稱",
  withdrawal_limit: "提款限額",
  limit_id: "限制 ID",
  limit_name: "限制名稱",
  daily_amount: "每日金額",
  daily_frequency: "每日頻率",
  promotion_id: "促銷ID",
  promotion_name: "促銷名稱",
  withhold_bonus: "扣留獎金",
  withhold_amount: "預扣金額",
  withhold_amt: "扣留 Amt",
  max_withdraw_amt: "最大提款金額",
  max_withdraw_amount: "最高提款金額",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",
  sunday: "星期日",
  start_time: "開始時間",
  end_time: "結束時間",
  day: "日 |天",
  coupon_status: "優惠券狀態",
  campaign_id: "活動ID",
  campaign_name: "活動名稱",
  promotion_group: "推廣組",
  referee_list: "《裁判名單》",
  account_verified: "帳戶已驗證",
  verified_date: "驗證日期",
  ticket_list: "門票清單",
  vip_id: "貴賓ID",
  vip_name: "貴賓姓名",
  self_rebate_rate: "「自我回贈率（%）」",
  downline_rebate_rate: "下線返傭率（%）",
  provider: "提供者",
  match_id: "」匹配ID",
  home_team: "主隊",
  away_team: "客隊",
  home_team_new: "主隊新",
  away_team_new: "客隊新",
  updated_by: "更新者",
  updated_on: "更新時間",
  home_score: "主場比分",
  away_score: "客場比分",
  home_score_new: "Home Score New",
  away_score_new: "客場得分新",
  team: "團隊",
  match_time: "比賽時間",
  match_round: "比賽回合",
  home_group: "家庭組",
  away_group: "客場組",
  match: "匹配",
  match_status: "」匹配狀態",
  insert: "插入",
  pin: "銷",
  bet_list: "投注清單",
  result_list: "結果清單",
  bet_id: "投注 ID",
  bet_home: "賭回家",
  bet_away: "賭走",
  bet_on: "賭上",
  min_deposit: "最低存款",
  min_withdrawal: "最小提款",
  raise_deposit_ticket: "提出存款申請",
  method: "方法",
  one_time_depositor: "一次性存款人",
  current_month_non_depositor: "當月非存款人",
  current_month_no_login: "當月無登錄",
  ticket_date: "出票日期",
  ftd_amount: "首次存款金額",
  bonus_issue: "紅利發放",
  promotion_summary: "促銷摘要",
  promotion_summary_detail: "促銷摘要（詳細）",
  claim_frequency: "索賠頻率",
  provider_list: "提供者清單",
  platform_winlose: "平臺Winlose",
  adjustment_amount: "調整金額",
  referee_count: "推薦人數",
  category: "類別",
  update_vip: "更新 VIP",
  promotion_signup: "促銷註冊",
  provider_bet_limit: "提供商投注限額",
  update_member_bet_limit: "更新會員投注上限",
  bet_limit: "投注限額",
  sports_game: "體育/遊戲",
  league_name: "聯賽名稱",
  home_team_name: "主隊名稱",
  away_team_name: "客隊名稱",
  wl_status: "Winlose Status",
  available_bank_account: "可用銀行帳戶",
  group_bank_account: "團體銀行帳戶",
  edit_bank_group: "編輯銀行群組",
  edit_bank_account_group: "編輯銀行帳戶群組",
  redeposit: "重新存款",
  upline: "上線",
  downline: "下線",
  available_promotion: "可用促銷",
  group_promotion: "團體推廣",
  edit_promotion_group: "編輯優惠群組",
  edit_promotion_group_norm: "管理群組中的優惠",
  balance_before: "之前的平衡",
  balance_after: "之後的平衡",
  signup_count: "註冊人數",
  verified_count: "已驗證人數",
  active_member: "活躍會員",
  ftd_count: "首次存款人數",
  daily_summary_company: "每日總結（公司）",
  daily_summary_operator: "每日總結（運算員）",
  daily_summary_member: "每日總結（成員）",
  daily_ledger_operator: "每日帳本（運營商）",
  bonus_list: "獎金清單",
  ltd_date: "LTD 日期",
  adjustment_log: "調整日誌",
  get_inbox: "獲取收件匣",
  is_claimed: "被認領",
  mix_parlay: "混合連贏",
  event: "活動",
  result_changes_log: "結果更改日誌",
  view_detail: "查看詳情",
  total_referee: "總裁判",
  verified_signup: "已驗證/註冊",
  ftd: "FTD |首次存款",
  raw_msg: "原始消息",
  unselect_all: "取消全選",
  select_all: "全選",
  edit_bet_limit: "編輯投注上限",
  provider_game_off: "提供商遊戲關閉",
  provider_hot_game: "提供商熱盤",
  game_id: "遊戲 ID",
  game_list: "遊戲清單",
  off_list: "不在名單上",
  provider_rtp: "提供者 RTP",
  rtp: "RTP",
  signup_date: "註冊日期",
  free_credit: "免費信用額度",
  downline_rebate: "下線返利",
  game_rebate: "遊戲返利",
  rebate: "返利",
  ftd_date: "FTD 日期",
  provider_winlose_company: "提供者 Winlose（公司）",
  provider_winlose_operator: "提供者 Winlose（運營商）",
  already_hit: "已經命中",
  ongoing: "進行中",
  members_export: "成員（出口）",
  get_recent_deposit: "取得最近的存款",
  recent_deposit: "近期存款",
  survey_list: "調查清單",
  modified_on: "修改日期",
  cms: "CMS",
  announcement_banner: "公告橫幅",
  promotion_banner: "促銷橫幅",
  slide_banner: "幻燈片橫幅",
  seo_page: "SEO頁面",
  en_title: "標題 （EN）",
  cn_title: "標題（CN）",
  local_title: "標題（本地）",
  en_img: "圖像（英文）",
  cn_img: "圖像（中國）",
  local_img: "圖像（本地）",
  before_login: "登錄前",
  after_login: "登錄後",
  en: "EN",
  move_up: "向上移動",
  move_down: "向下移動",
  banner_type: "橫幅類型",
  default_order: "默認訂單",
  item_order: "項目順序",
  title: "標題",
  banner_id: "橫幅ID",
  order: "訂單",
  body: "身體",
  en_image: "圖像（英文）",
  local_image: "圖像（本地）",
  move: "移動",
  en_img_desktop: "Image Desktop （EN）",
  cn_img_desktop: "Image Desktop （CN）",
  local_img_desktop: "圖像桌面（本地）",
  en_img_mobile: "Image Mobile （英文）",
  cn_img_mobile: "Image Mobile （CN）",
  local_img_mobile: "Image Mobile （LOCAL）",
  login_required: "需要登錄",
  new_window_tab: "新視窗/選項卡",
  current_page: "當前頁面",
  target: "目標",
  event_filter: "ตัวกรองเหตุการณ์",
  alt: "替代",
  href: "赫雷夫",
  image_desktop: "桌面圖像",
  image_mobile: "移動圖像",
  en_alt: "Alt （EN）",
  local_alt: "Alt （LOCAL）",
  en_href: "Href （EN）",
  local_href: "Href （LOCAL）",
  en_image_desktop: "桌面圖像 （EN）",
  active_period: "活躍期",
  en_item: "專案（英文）",
  local_item: "專案（本地）",
  meta_title: "元標題",
  meta_keywords: "元關鍵詞",
  meta_url: "元網址",
  meta_canonical: "元規範",
  meta_author: "元作者",
  meta_publisher: "元出版商",
  meta_lang: "元郎",
  meta_desc: "元描述",
  meta_image: "元圖像",
  page: "頁面",
  item: "專案",
  remove_desktop_image: "刪除桌面映射",
  remove_mobile_image: "刪除移動圖像",
  page_name: "頁面名稱",
  login_date: "登錄日期",
  ftd_amount_min: "最低 FTD 金額",
  ftd_amount_max: "最高 FTD 金額",
  fl_provider_code: "「首發供應商」",
  fl_game_id: "首次啟動遊戲ID",
  fl_game_name: "首次啟動遊戲名稱",
  top_deposit: "頂額存款",
  top_withdrawal: "頂級提款",
  top_promotion: "頂級促銷",
  outstanding_balance: "未償餘額",
  last_update_time: "上次更新時間",
  trace: "追蹤",
  trace_outstanding: "跡線突出",
  outstanding: "優秀",
  clear_outstanding: "清除未結金額",
  meta_image_url: "元圖像網址",
  member_bonus: "會員獎金",
  crm_list: "「客戶關係管理清單」",
  advance_search: "高級搜索",
  deposit_count_from: "存款計數",
  deposit_count_to: "存款計數至",
  deposit_amount_from: "存款金額來自",
  deposit_amount_to: "存款金額至",
  min_day_no_login: "Min. Day No Login",
  min_day_no_deposit: "最少天無存款",
  last_login: "「上次登錄」",
  last_deposit: "最後存款",
  phone: "電話",
  email: "「電子郵件」",
  ip_whitelist: "IP白名單",
  ip: "IP",
  payment_option: "付款方式",
  payment_mode: "付款方式",
  payment_desc: "付款說明",
  success: "成功",
  failed: "失敗",
  bank_member_ewallet: "「銀行會員（電子錢包）」",
  processing: "處理",
  recipient_bank_id: "收款銀行代碼",
  recipient_bank_acc_no: "收款銀行帳號",
  ticket_auto_withdrawal_log: "門票日誌（自動提款）",
  resubmit_ticket: "」重新提交工單",
  ticket_export: "票據（出口）",
  export_deposit: "出口（押金）",
  export_deposit_all: "全部匯出（存款）",
  export_withdrawal: "出口（退出）",
  export_withdrawal_all: "全部匯出（提款）",
  export_member_all: "全部匯出（成員）",
  processed_rejected: "已處理（已拒絕）",
  channel: "通道",
  influencer: "影響者",
  ticket_id: "門票 ID",
  recommend: "推薦推薦",
  sequence: "序列",
  statement_info: "報表資訊",
  slots: "老虎機",
  livecasino: "真人娛樂場",
  sportsbook: "體育博彩",
  cockfight: "鬥雞",
  member_list: "會員名單",
  operator: "運算子",
  game_balance: "遊戲平衡",
  claim_limit: "索賠限額",
  max_withdraw_multiple: "最大提款倍數",
  payment_gateway: "支付閘道",
  min_limit: "最小限制",
  max_limit: "最大限額",
  total: "總計",
  rebate_summary: "返利匯總",
  rebate_summary_daily: "返利匯總日報",
  rebate_member: "回贈會員",
  self: "自我",
  system_balance: "系統平衡",
  rejected_onload: "已拒絕（載入）",
  no_bonus: "沒有獎金",
  audit_ticket: "稽核單",
  review_ticket: "審核單",
  edit_promotion_group_norm_seq: "管理促銷群組順序",
  signup_bonus: "註冊獎勵",
  settlement_type: "結算類型",
  carry_over: "結轉",
  comm_sports: "委員會（體育）",
  comm_slots: "傭金（老虎機）",
  comm_livecasino: "傭金（真人娛樂場）",
  comm_cockfight: "委託（鬥雞）",
  comm_others: "傭金（其他）",
  update_comm: "更新佣金",
  update_carry_over: "更新結轉",
  ewallet: "電子錢包",
  withdrawal_list: "提款清單",
  audit_withdrawal: "審計撤回",
  daily_withdrawal: "每日提款",
  adjustment_log_affiliate: "調整日誌",
  daily_statement_affiliate: "每日結單（代理）",
  earning: "賺錢",
  pnl: "損益",
  review_affiliate_ticket: "審核聯盟單",
  audit_affiliate_ticket: "稽核聯盟單",
  turnover_downline: "營業額（下線）",
  valid_turnover_downline: "有效營業額（下線）",
  winlose_downline: "WinLose（下線）",
  bet_count_downline: "投注計數（下線）",
  turnover_member: "營業額（會員）",
  valid_turnover_member: "有效營業額（會員）",
  winlose_member: "WinLose（會員）",
  bet_count_member: "投注計數（會員）",
  dashboard_affiliate: "儀錶板（代理）",
  total_agent: "總代理",
  top_turnover: "最高營業額",
  bonus_count: "獎金計數",
  deposit_amount_downline: "存款金額（下線）",
  deposit_count_downline: "存款計數（下線）",
  bonus_amount_downline: "獎金金額（下線）",
  bonus_count_downline: "獎金計數（下線）",
  deposit_amount_member: "存款金額（會員）",
  deposit_count_member: "存款數量（會員）",
  bonus_amount_member: "獎金金額（會員）",
  bonus_count_member: "獎金數量（會員）",
  verified: "已驗證",
  round_id: "整數ID",
  unfinish_round: "未完成回合",
  smartico_bonus_report: "Smartico 獎金報告",
  unclaimed_amount: "無人認領金額",
  claimed_amount: "申索金額",
  unclaimed_count: "無人認領的計數",
  claimed_count: "聲稱的計數",
  submit_time: "創建日期",
  deposit_time: "修改日期",
  funds_list: "門票清單",
  fund_transfer_provider: "資金轉帳提供者",
  daifu_list_auto_withdrawal: "門票清單（自動提款）",
  btn_href: "按鈕 Href",
  btn_text: "按鈕文本",
  recent_inbox_claim: "最近的收件匣聲明",
  raise_deposit_ticket_gateway: "提出存款申請（支付閘道）",
  gateway_acc: "網關帳戶",
  provider_winlose_member: "提供者 Winlose（成員）",
  review_by: "審稿人",
  daifu_list_auto_withdrawal_export: "票據導出（自動提款）",
  retention: "保留",
  current_month_active_user: "當月活躍使用者",
  current_month_active: "當月有效",
  first_month: "第一個月",
  fmwinlose: "FMWinlose",
  fmdeposit_amount: "FM存入金額",
  cohort: "佇列",
  promotion_withdrawal_summary: "促銷活動退出摘要",
  promotion_withdrawal_summary_detail: "促銷活動退出摘要（詳細）",
  unique_player: "獨特的玩家",
  year: "年 |年",
  audit_time_modified: "修改日期",
  audit_time_created: "創建日期",
  approve_time: "修改日期",
  unique_login_count: "獨立登入次數",
  unique_deposit_count: "獨立存款次數",
  unique_withdrawal_count: "獨立提款次數",
  second_deposit_count: "第二次存款次數",
  unique_login: "唯一登錄",
  unique_withdrawal: "唯一提款",
  second_deposit: "第二筆存款",
  deposit_withdrawal_different: "存款與提款差額",
  ngr: "NGR",
  audit_list: "審計清單",
  rollback_count: "回滾計數",
  rejected_ticket_id: "被拒絕的工單 ID",
  rollback: "回滾",
  recipient_bank_acc_holder: "收款銀行帳戶持有人",
  reject_date: "拒絕日期",
  processing_date: "處理日期",
  manual_approve: "批准（手動）",
  pending_review_funds: "待處理和審核工單",
  table_id: "表 ID",
  member_label: "成員標籤",
  label_name: "標籤名稱",
  label: "標籤",
  available_label: "可用標籤",
  iframe: "iframe",
  iframe_url: "iframe URL",
  exchange_rate: "匯率",
  rate: "費率",
  rate_php: "費率 PHP",
  ticket_withdrawal_rollback: "票證撤回回滾",
  smartico_bonus_report_expired: "Smartico 獎金報告（已過期）",
  reward_type: "獎勵類型",
  turnover_rebate: "營業額返利",
  turnover_rebate_1: "VIP 級別",
  turnover_rebate_2: "營業額等級",
  vip_cycle_day: "貴賓週期日",
  is_addon: "是外掛程式",
  no_reward: "沒有獎勵",
  cash: "現金",
  cs: "客戶服務",
  social_platform: "社交平臺",
  edit_vip: "編輯 VIP",
  edit_vip_provider: "編輯VIP供應商",
  turnover_tier: "營業額等級",
  rebate_rate: "返傭率",
  edit_turnover_tier: "編輯流水等級",
  delete_turnover_tier: "刪除營業額等級",
  vip_log: "VIP日誌",
  member_full_record: "成員完整記錄",
  before: "之前",
  after: "之後",
  maintain: "維護",
  actual_rebate: "實際回扣",
  rounded_rebate: "四捨五入的回扣",
  rebate_mode: "返利模式",
  inbox_id: "收件匣 ID",
  rebate_type: "返利類型",
  promotion_type: "促銷類型",
  bonus_rate_1: "利率 1（%）",
  bonus_rate_2: "費率 2（%）",
  bonus_rate_3: "利率 3（%）",
  bonus_rate_4: "費率 4（%）",
  bonus_rate_5: "費率 5（%）",
  bonus_rate_6: "費率 6（%）",
  bonus_rate_7: "費率 7（%）",
  bonus_rate_8: "利率 8（%）",
  bonus_rate_9: "利率 9（%）",
  bonus_rate_10: "費率 10（%）",
  delete_all: "全部刪除",
  rescue_fund: "紓困基金",
  up: "向上",
  down: "下",
  rate_percent: "費率%",
  cycle: "迴圈",
  actual_amount: "實際金額",
  rounded_amount: "四捨五入金額",
  rescue_id: "救援ID",
  rescue_name: "救援名稱",
  min_lose: "Min Lose",
  max_payout: "最高支付額",
  payout_method: "支付方式",
  target_group: "目標群體",
  member_vip_id: "會員VIP ID",
  daily: "每日",
  weekly: "《週刊》",
  monthly: "《月刊》",
  edit_batch: "編輯批處理",
  current_level: "當前水準",
  next_level: "下一個層次",
  bet_value: "投注價值",
  line_bet: "線下注",
  total_round: "總輪數",
  audit_by: "審計者",
  possible_next_level: "可能的下一個級別",
  maintain_deposit: "維持存款",
  maintain_turnover: "保持營業額",
  starting_deposit: "起始存款",
  starting_turnover: "起始營業額",
  cycle_deposit: "迴圈存款",
  cycle_turnover: "周期周轉",
  vip_list: "貴賓名單",
  up_maintain: "向上維護",
  down_lowest: "最低",
  manual: "手動",
  daily_winlose_game: "每日贏輸（遊戲）",
  actionaff: "作（代理）",
  onload: "上載",
  update_status: "更新狀態",
  role_settings: "角色設置",
  customer_services: "客戶服務",
  marketing: "营銷",
  finance: "金融",
  payment: "付款",
  risk_management: "風險管理",
  pt: "PT",
  wallet_history: "錢包歷史",
  ticket_amount: "門票金額",
  ignore_risk: "忽略風險",
  permitted_amount: "允許數量",
  all_pending_ticket: "所有待處理的工單",
  rescue_fund_summary: "《紓困基金摘要》",
  rescue_fund_summary_daily: "《救助基金總結日報》",
  rescue_fund_member: "拯救基金成員",
  master: "師父",
  account_type: "帳戶類型",
  freeze: "凍結",
  domain_member_setup: "成員網站域設置",
  domain: "域",
  domain_list: "域名清單",
  domain_application: "域名申請",
  domain_status: "域名狀態",
  domain_group: "域組",
  operator_id: "運營商ID",
  domain_type: "域名類型",
  module: "模組",
  template: "範本",
  custom: "定制",
  default: "預設",
  payment_provider: "支付提供者",
  payment: "付款",
  deactivate: "非活動",
  name_server: "名稱伺服器",
  server_account: "「伺服器帳戶」",
  service_provider: "服務提供者",
  process: "過程",
  provider_operator: "提供者運營商",
  bet_limit_member: "@：ui.bet_limit （@：ui.member）",
  global: "全域設置",
  second_id: "第二個ID",
  unverified: "未經驗證",
  pt_affiliate: "代理平台費用（%）",
  recipient_bank: "收款銀行",
  deposit_type: "存款類型",
  security_fund: "安全基金",
  adjust_balance_op: "Adjust 運營商錢包",
  adjust_security_deposit_op: "調整運營商安全基金",
  marquee: "跑馬燈",
  marquee_content: "選馬燈內容",
  edit_marquee: "編輯選框",
  domain_available: "可用域",
  daily_withdrawal_frequency: "每日提款頻率",
  maintenance: "維護",
  max_withdrawal: "最高提款額",
  min_balance: "最低結餘",
  affiliate_report: "「代理報告」",
  cash_balance: "現金結餘",
  copy_success: "複製成功！",
  copy_failed: "複製失敗！",
  your_website: "您的網站",
  correction_promo: "添加充值活動",
  others: "其他",
  audit_log: "審計日誌",
  view: "視圖",
  price: "價格",
  package_level: "包級別",
  bo_right: "BO對",
  english: "英語",
  simplified_chinese: "中文（中國）",
  traditional_chinese: "中文（臺灣）",
  philippine: "菲律賓",
  thai: "泰語",
  vietnamese: "越南人",
  indonesian: "印尼語",
  myanmar: "緬甸",
  japanese: "日語",
  korean: "韓語",
  package_type: "包類型",
  full_back_office_access_right: "完全後台訪問許可權",
  read_only_back_office: "只讀後台",
  language: "語言",
  lang_code: "語言代碼",
  description: "描述",
  provider_type: "提供者類型",
  logo: "標識",
  theme_provider: "主題提供者",
  theme_content: "主題內容",
  content_id: "內容ID",
  content_desc: "內容描述",
  theme_content_position: "主題內容定位",
  theme: "主題",
  theme_code: "主題代碼",
  theme_name: "主題名稱",
  color: "顏色",
  position: "位置",
  site_name: "網站名稱",
  theme_color: "主題色",
  theme_purchased: "購買的主題",
  total_purchased: "總購買量",
  external_id: "External ID",
  purchase: "購買",
  total_site: "總網站",
  content_setup: "內容設置",
  site_list: "網站清單",
  site_id: "網站 ID",
  draft_version: "草稿版本",
  prod_version: "正式版本",
  production_version: "生產版",
  info: "資訊",
  setting: "設置",
  site_info: "網站資訊",
  menu: "功能表",
  game_menu: "遊戲功能表",
  special_menu: "特別功能表",
  setting_menu: "「設置功能表」",
  error: "錯誤",
  sync_all: "全部同步",
  theme_content_group: "主題內容組",
  content_group: "內容組",
  content_group_desc: "內容組描述",
  parent_content_id: "家長內容 ID",
  bo_default_domain: "BO 預設域",
  domain_id: "功能變數名稱ID",
  deactive: "不主動",
  site_sync: "網站同步",
  upload: "上傳",
  comingSoon: "即將推出",
  profile_setting: "配置檔設置",
  bank: "銀行",
  company: "公司",
  own: "擁有",
  operator_setting: "操作員設置",
  external_id: "外部 ID",
  ticket: "票",
  bank_owner: "銀行擁有者",
  exchanged_currency: "兌換貨幣",
  company_bank_owner: "公司銀行擁有者",
  ticket_list_member: "門票清單（會員）",
  game_name_exclude: "排除遊戲名稱",
  tab: "標籤",
  about_us: "關於我們",
  privacy_policy: "隱私政策",
  responsible_gaming: "負責任的博彩",
  banking: "銀行業",
  faqs: "常見問題",
  advertisement: "廣告",
  px_pixel_id: "PX 像素 ID",
  px_token: "PX代幣",
  af_dev_key: "Af Dev Key",
  af_apps_id: "Af 應用程式ID",
  pp_tid: "PP TID",
  pp_pid: "PP PID",
  pp_aid: "PP援助",
  gtm_id: "GTM ID",
  service_provider_url: "服務提供者 URL",
  script_inject: "腳本注入",
  head_script: "頭部劇本",
  body_script: "正文",
  ads_id: "廣告ID",
  member_detail: "會員詳情",
  memberreport: "成員報告",
  member_log: "會員日誌",
  general: "一般",
  top_theme: "頂級主題",
  hot_game: "《熱門遊戲》",
  hot_list: "《熱榜》",
  new_game: "新遊戲",
  popular_game: "熱門遊戲",
  featured_game: "精選遊戲",
  new_list: "新清單",
  popular_list: "熱門榜",
  featured_list: "精選清單",
  provider_new_game: "提供商新遊戲",
  provider_popular_game: "提供商熱門遊戲",
  provider_featured_game: "提供者特色遊戲",
  website: "網站",
  site_customization: "網站定製",
  export_all: "全部匯出",
  export_one: "匯出（當前頁面）",
  daily_ledger: "《每日帳本》",
  daily_ledger_member: "每日帳本（會員）",
  promotion_signup_unused: "未使用的註冊促銷",
  promotion_signup_ongoing: "持續註冊促銷",
  promotion_signup_winlose: "註冊促銷贏",
  promotion_signup_winlose_operator: "註冊推廣贏輸（運營商）",
  promotion_signup_winlose_member: "註冊促銷贏家（會員）",
  total_player_balance: "玩家總餘額",
  search_all: "全部搜索",
  mbsetting: "設置",
  todays_highlights: "今日看點",
  deposit_player: "存款玩家",
  withdrawal_player: "提款玩家",
  kill_rate: "《殺傷率》、",
  login_player: "登錄玩家",
  operation_management: "作",
  game_management: "遊戲",
  member_management: "會員",
  affiliate_management: "代理",
  promotion_management: "促銷",
  mbcampaign: "活動",
  promo_allday: "《一整天》",
  promo_daily: "每日",
  promo_daily_first_deposit: "「每日首存」",
  promo_deposit_monthly: "每月存款次數",
  promo_deposit_signup: "存款計數註冊",
  promo_deposit_weekly: "每周存款計數",
  promo_newbie: "新手",
  promo_once: "一次",
  dd_review: "回顧",
  game_provider_management: "提供者",
  exchanged_amount: "兌換金額",
  operator_summary: "運算子摘要",
  business_id: "企業ID",
  game_name_exclude_log: "遊戲名稱排除日誌",
  cn: "CN",
  local: "本地",
  taken: "拿走",
  receiver_bank: "收盤銀行",
  receiver_bank_acc_no: "接管銀行賬戶編號",
  receiver_bank_acc_holder: "接管銀行帳戶持有人",
  add_balance: "添加餘額",
  deduct_balance: "扣除餘額",
  sync_site_content: "同步網站內容",
  payment_setting: "付款設置",
  payment_own: "擁有",
  payment_global: "全球",
  livechat: "「在線聊天」",
  chat_id: "LiveChat 許可證密鑰",
  chat_provider: "即時聊天提供者",
  auto_cycle: "迴圈",
  auto_all: "全部",
  completed_amount: "已完成金額",
  website_launched: "網站啟動",
  total_operators: "總算子",
  today_active: "今日活躍",
  new_player_verified_signup: "新玩家驗證/註冊",
  total_players: "總玩家數",
  depo_withdrawal_diff: "存提款差額",
  claim_count: "索賠計數",
  ggr: "GGR",
  member_balance: "會員結餘",
  players: "玩家",
  provider_pt: "提供者 PT",
  base: "基地",
  topup_id: "充值ID",
  credential: "憑證",
  credential_1: "憑證 1",
  credential_2: "憑證 2",
  credential_3: "憑證 3",
  credential_4: "憑證 4",
  credential_5: "憑證 5",
  credential_6: "憑證 6",
  credential_7: "憑證 7",
  credential_8: "憑證 8",
  credential_9: "證書 9",
  credential_10: "證書 10",
  limit: "限制限制",
  create: "創造",
  hint: "提示",
  quickSetup: "快速設置",
  next: "下一步",
  setUpTheme: "「設置主題」",
  checkOut: "退房",
  standardPackage: "標準套餐",
  siteName: "網站名稱",
  information: "資訊",
  useThisTemplate: "使用此範本",
  summary: "總結",
  createOperatorAccount: "創建運營商帳戶",
  operatorId: "運營商ID",
  operatorPwd: "操作員密碼",
  new_website: "新網站",
  operator_information: "運營商資訊",
  bo_link: "BO連結",
  daily_summary_sms: "每日摘要短信",
  daily_summary_sms_operator: "每日摘要短信運營商",
  daily_summary_sms_operator_detail: "每日摘要短信運營商詳細資訊",
  sms_count: "短信計數",
  provider_winlose_operator_pt: "提供者 Winlose（運營商 PT）",
  pt_on: "PT 開啟",
  share_operator: "股份運營商",
  share_company: "股份公司",
  token_log: "令牌日誌",
  template_code: "範本代碼",
  template_name: "範本名稱",
  mini_game: "小遊戲",
  max_game_reward: "遊戲獎勵上限",
  max_chance_per_day: "每天最大機會",
  is_recurring_chance: "重複",
  token_request: "令牌",
  enabled: "啟用啟用",
  disabled: "禁用",
  unlimited: "無限",
  max_chance_unlimited: "每天最大機會無限",
  mini_game_template: "小遊戲範本",
  reward_code: "獎勵代碼",
  reward_name: "獎勵名稱",
  reward_description: "獎勵說明",
  reward_probability: "獎勵概率",
  total_game: "總遊戲",
  total_played_mini_game: "總玩過的小遊戲",
  total_played_mini_game_detail: "小遊戲總玩量詳情",
  total_played_mini_game_detail_operator: "總玩小遊戲詳情（幹員）",
  daily_pnl_operator: "每日損益（運營商）",
  token: "令牌",
  token_1: "代幣 1",
  token_2: "代幣 2",
  token_3: "令牌3",
  token_4: "代幣4",
  token_5: "代幣5",
  token_6: "令牌6",
  token_7: "代幣7",
  cash_1: "現金 1",
  cash_2: "現金2",
  cash_3: "現金3",
  cash_4: "現金 4",
  cash_5: "現金 5",
  cash_6: "現金6",
  cash_7: "現金 7",
  daily_login: "每日簽到（每日登錄）",
  daily_login_update: "每日簽到（每日登錄）更新",
  game_result_reward: "遊戲結果（獎勵）",
  current_streak: "當前連勝",
  login_streak: "登錄連勝",
  total_token: "代幣總數",
  total_mini_game_token_used: "使用的小遊戲代幣總量",
  total_mini_game_token_used_detail: "使用小遊戲代幣總量詳情",
  total_mini_game_token_used_detail_operator: "小遊戲代幣使用總量明細（運營商）",
  total_reward: "總獎賞",
  total_mini_game_reward: "小遊戲總獎勵",
  total_mini_game_reward_detail: "小遊戲獎勵總詳情",
  total_mini_game_reward_detail_operator: "小遊戲獎勵總詳情（幹員）",
  token_balance: "代幣餘額",
  free_game_token: "免費遊戲代幣",
  bo_url: "後台網址",
  copied: "複製",
  callback: "回調",
  api: "API",
  prefix: "前綴",
  delimiter: "分隔符",
  url_callback_deposit: "充值回調 URL",
  url_callback_withdrawal: "提現回調 URL",
  url_callback_affiliate: "代理回撥 URL",
  url_api_deposit: "存款回調 URL （API）",
  url_api_withdrawal: "提現回調 URL （API）",
  url_api_balance: "餘額回傳 URL （API）",
  prefix_deposit: "存款前綴",
  prefix_withdrawal: "提款前綴",
  prefix_affiliate: "代理前綴",
  prefix_delimiter: "分隔符前綴",
  merchant: "商人",
  app_id: "應用ID",
  secret_key: "金鑰",
  deposit_secret_key: "存款金鑰",
  withdrawal_secret_key: "提款金鑰",
  partners: "合作夥伴",
  partner_name: "合作夥伴名稱",
  win: "贏",
  manifest: "清單",
  crop: "裁剪",
  cropImage: "裁剪圖像",
  api_url: "API URL",
  start_date_time: "開始日期時間",
  end_date_time: "結束日期時間",
  authentication_key: "認證金鑰",
  one_week: "1周",
  two_week: "2周",
  one_month: "1個月",
  two_month: "2個月",
  six_month: "6個月",
  edit_promotion_end_date: "編輯促銷結束日期",
  android_app_link: "Android 應用連結",
  add_android_app_link: "添加Android應用連結",
  operator_details: "運營商詳細資訊",
  bsb: "BSB",
  payid: "支付ID",
  cuit: "CUIT",
  merchant_key: "商家鑰匙",
  aes_key: "AES 金鑰",
  paycode: "PayCode",
  api_key: "API 金鑰",
  referral: "推薦獎勵",
  minimum_deposit: "最低存款額",
  minimum_withdrawal: "最低提款額",
  maximum_withdrawal: "最大提款額",
  cpi: "CPI",
  cpi_enrol: "CPI 登記",
  interested: "有興趣",
  non_pickup: "未接聽",
  invalid: "無效",
  cpi_member_list: "CPI 成員列表",
  leaderboard: "排行榜",
  capacity: "容量",
  reward_count: "獎勵數量",
  is_settled: "已結算",
  settlement_date: "結算日期",
  prize: "獎品",
  count: "數量",
  multiplier: "倍數",
  ranking: "排名",
  leaderboard_ranking: "排行榜排名",
  joined_date: "加入日期",
  ready: "空閒",
  busy: "忙碌",
  phone_list: "電話列表",
  single: "單筆",
  batch: "批量",
  cpi_operator_phone_list: "CPI 操作員電話列表",
  selected: "已選擇",
  call: "撥打",
  private_key: "私鑰",
  public_key: "公鑰",
  multi_call: "多次呼叫",
  add_custom: "新增自訂",
  custom_list: "自訂清單",
  assignee: "被指派人員",
  urgency: "緊急程度",
  urgency_1: "低",
  urgency_2: "中等",
  urgency_3: "高",
  edit_custom: "編輯自訂",
  cpi_custom_list: "CPI 自訂清單",
  free_coin_signup: "免費點數（註冊）",
  free_coin_daily: "免費點數（每日）",
  free_coin_min_withdrawal: "最低提領（免費點數）",
  free_coin_per_unit: "免費點數匯率（點數 = {currency} 1）",
  adjust_free_balance: "調整免費餘額",
  adjust_free_balance_log: "免費餘額記錄",
  signup: "註冊",
  adjust: "調整",
  ai_assistant: "AI 助手",
  en_name: "名稱 (EN)",
  cn_name: "名稱 (CN)",
  local_name: "名稱 (本地)",
  img_small: "圖片 (小)",
  img_large: "圖片 (大)",
  small_image: "小圖",
  large_image: "大圖",
  forgot_password: "忘記密碼",
  update_password: "更新密碼",
  contact: "聯絡方式",
  keyss: "鑰匙",
  iv: "IV",
  callback_public_key: "回调公鑰",
  free_game: "免費遊戲",
  version_no: "版本號",
  client_id: "客戶ID",
  symmetric_key: "對稱金鑰",
  deposit_token: "存款代幣",
  withdrawal_token: "提領代幣",
  tac_bank: "驗證碼 (銀行)",
  tac_login: "驗證碼 (登入)",
  tac_signup: "驗證碼 (註冊)",
  tac_signup_aff: "驗證碼 (加盟註冊)",
  merchant_name: "商戶名稱",
  tele_status: "Tele 狀態",
  follow_up: "後續跟進",
  call_type: "通話類型",
  on_call_list: "通話清單中",
  inbox_valid_day: "收件匣有效天數",
  manual_deposit: "手動存款",
  withdrawal_result: "提現結果",
  widget_id: "小工具 ID",
  property_id: "屬性 ID",
  referee: "被推薦人獎勵",
  game_result_free_slots: "遊戲結果（免費老虎機）",
  crypto_address: "加密地址",
  crypto_network: "加密網路",
  crypto: "加密貨幣",
  exchange_currency: "兌換貨幣",
  base_rate: "基礎匯率",
  white_label: "White Label",
  aggregator: "聚合商",
  deposit_rate: "存款費率",
  withdrawal_rate: "提款費率",
  pending_bet_list_wbet: "待處理投注列表（WBET）",
  bet_amount: "投注金額",
  actual_bet_amount: "實際投注金額",
  pending_bet_list_others: "待處理投注列表（其他體育博彩）",
  dob: "出生日期",
  mail_address: "郵寄地址",
  crypto_withdrawal: "加密貨幣提款",
  institute_bank_code: "機構銀行代碼",
  pending_bet_list_9w: "待處理投注列表（9W）",
  linkage: "關聯",
  linkage_op: "關聯操作員",
  member_linkage: "會員關聯",
  risk_weight: "風險權重",
  full_linkage: "完整關聯",
  total_risk_score: "總風險評分",
  linkage_value: "關聯值",
  source_occurrence_count: "來源出現次數",
  source_last_seen_at: "最後出現時間（來源）",
  target_occurrence_count: "目標出現次數",
  target_last_seen_at: "最後出現時間（目標）",
  member_linkage_detail: "會員關聯詳情",
  merchant_uid: "商戶ID",
  merchant_no: "商戶編號",
  slot_view: "老虎機檢視",
  settlement_list_affiliate: "結算列表（代理）",
  source: "來源",
  earning_breakdown: "收益明細",
  deposit_bonus: "存款紅利",
  winlose_turnover: "輸贏/流水",
  cost: "成本",
  promotion_voucher: "優惠券",
  voucher_id: "折價券 ID",
  voucher_cash: "折價券現金",
  ticketvoucher: "工單憑證",
  ticket_voucher_list_member: "工單憑證列表（會員）",
  ticket_voucher_list: "工單憑證列表",
  pending_review_funds_voucher: "待處理與審核中的工單憑證",
  all_pending_ticket_voucher: "所有待處理工單憑證",
  ticket_voucher_detail: "工單憑證詳情",
  raise_deposit_ticket_voucher: "建立入金工單憑證",
  raise_deposit_ticket_voucher_gateway: "建立入金工單憑證（閘道）",
  sos: "SOS 充值",
  sos_accumulate_deposit: "SOS 充值（累計存款）",
  greeting: "問候語",
  message: "訊息",
  get_voucher: "取得憑證",
  get_message: "取得訊息",
  voucher: "憑證",
  code: "代碼",
  redeemed_by: "兌換人",
  redeemed_by_operator: "兌換人（操作員）",
  redeemed_at: "兌換時間",
  created_at: "建立時間",
  redeemed: "已兌換",
  member_sos_click_log: "會員 SOS 點擊紀錄",
  member_wallet_voucher_log: "會員錢包憑證紀錄",
  member_voucher_redeemed_log: "會員憑證兌換紀錄",
  action_by_operator: "操作（操作員）",
  redeem_cash: "兌換現金",
  generate_voucher: "產生憑證",
  url_api_freecredit: "免費信用回調 URL",
  prefix_freecredit: "免費信用前綴",
  free_credit_member: "免費信用會員",
  free_credit_provider: "免費信用供應商",
  ticket_detail_fcp: "工單詳情（免費信用供應商）",
  ticket_list_processed: "工單列表（已處理）",
  mission: "任務",
  non_slot_view: "非老虎機檢視",
  banner: "橫幅",
  trigger: "觸發條件",
  event_type: "事件類型",
  action_type: "動作類型",
  msg_greeting: "問候語（訊息）",
  msg_title: "標題（訊息）",
  msg_body: "內容（訊息）",
  send_message: "發送訊息",
  promo_type: "促銷類型",
  repeatable: "重複",
  rules: "規則",
  clear_outstanding_log: "清除未結清記錄",
  free_credit_withdrawal_amount: "免費額度提款金額",
  fc_withdrawal_amount: "FC 提款金額",
  frozen: "凍結",
  transferred: "已轉移",
  voucher_balance: "優惠券餘額",
  adjust_voucher_balance: "調整優惠券餘額",
  free_game_provider: "免費遊戲供應商",
  check_free_spin: "檢查免費旋轉",
  freespin_log: "免費旋轉紀錄",
  current_round: "當前回合",
  lines: "線數",
  expiry_interval_days: "到期間隔（天）",
  assign: "指派",
  game_code: "遊戲代碼",
  clear_free_credit: "清除免費額度",
  deposit_tier: "存款等級",
  point: "點數",
  top: "上方",
  bottom: "下方",
  leaderboard_banner: "排行榜橫幅",
  referral_banner: "推薦橫幅",
  tp_site: "Traffic Pool 網址",
  current_icon: "目前圖示",
  new_icon: "新圖示",
  voucher_redeemed: "已兌換優惠券",
  on_site: "站內",
  exclude_own: "排除自身",
  voucher_redeemed_detail: "已兌換優惠券詳情",
  gamification: "遊戲化",
  reward_rain: "Reward Rain",
  total_claimed_amount: "已領取總金額",
  min_amount: "最低金額",
  max_amount: "最高金額",
  reward_rain_session: "Reward Rain 場次",
  reward_rain_session_claim: "Reward Rain 場次領取",
  reward_amount: "獎勵金額",
  cta: "CTA",
  api_email: "API郵箱",
  api_password: "API密碼",
  url_callback_voucher: "優惠券 Callback URL",
  prefix_voucher: "優惠券前綴",
  slide_show: "投影片播放",
  ewallet_withdrawal: "電子錢包提款",
  news: "新聞",
  slug: "網址代稱",
  preview_body: "內容預覽",
  full_body: "完整內容",
  normal: "一般",
  free_balance: "免費餘額",
  schema: "結構描述",

  tt_pixel_id: "TT 像素 ID",
  tt_token: "TT代幣",

  free_spin_bulk_issue : "免費旋轉（批量發放）",
}